import React from "react";

export default function Watermark() {
  return (
    <div className="site-watermark" aria-hidden="true" data-testid="site-watermark">
      <img src="/img/apmercl-logo.png" alt="" />
    </div>
  );
}
